import React from 'react';
import { Button, Form, Input } from 'antd';
import { message } from '../services/toastMessage';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { resetPassword } from '../services/AuthenticationService';
import { TRANSLATIONS } from '../constants/translations';
import { translate } from '../helpers/translationHelper';

const ForgotPasswordForm: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const onFinish = async (values: { email: string }) => {
    try {
      await resetPassword(values.email); // Call resetPassword service
      message.success(translate(t, TRANSLATIONS.FORGOT_PASSWORD_SENT_SUCCESS));

      // Redirect to login page
      navigate('/login');
    } catch (error: any) {
      message.error(error.message || translate(t, TRANSLATIONS.FORGOT_PASSWORD_ERROR_FALLBACK));
    }
  };

  return (
    <div style={{ maxWidth: 400, margin: '50px auto', width: '100%', padding: '0 16px' }}>
      <h1>{translate(t, TRANSLATIONS.FORGOT_PASSWORD_TITLE)}</h1>
      <Form layout="vertical" onFinish={onFinish}>
        <Form.Item
          label={translate(t, TRANSLATIONS.EMAIL)}
          name="email"
          rules={[{ required: true, message: translate(t, TRANSLATIONS.EMAIL_MESSAGE) }]}
        >
          <Input />
        </Form.Item>
        <Form.Item>
          <Button type="primary" htmlType="submit" block>
            {translate(t, TRANSLATIONS.FORGOT_PASSWORD_SUBMIT_BUTTON)}
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default ForgotPasswordForm;
